import MockRepo from "../../../repos/MockRepo";

export default class PrenotazioneMockRepo extends MockRepo {
  getList(...p) {}
}
